import { render, staticRenderFns } from "./InventoryAnalysis.vue?vue&type=template&id=fc79cc94&scoped=true"
import script from "./InventoryAnalysis.vue?vue&type=script&lang=js"
export * from "./InventoryAnalysis.vue?vue&type=script&lang=js"
import style0 from "./InventoryAnalysis.vue?vue&type=style&index=0&id=fc79cc94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc79cc94",
  null
  
)

export default component.exports